import React from 'react'

export default function FaceFeature({ scale, scaleX, outline, verticalOffset }) {
  const transformOrigin = '11.2551 3.4951'
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g transform={`scale(${scale},${scale})`} transform-origin={transformOrigin}>
        <path
          d="M21.6401 1.3501C21.6401 1.3501 18.1701 2.57013 11.4601 2.57013C4.75011 2.57013 0.870117 1.3501 0.870117 1.3501C0.870117 1.3501 4.47012 5.64008 11.2501 5.64008C18.0301 5.64008 21.6401 1.3501 21.6401 1.3501Z"
          fill="white"
          stroke={outline}
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path d="M10.4399 5.18005L11.3399 3.03003L12.0899 5.18005H10.4399Z" fill="535659" />
      </g>
    </g>
  )
}
